import axios from '../../api/axiosInstance';
import { STATUS, extractErrorInfo } from './sharedfunction';

export async function submitFeedback({ type, description, current_route }) {
  try {
    const response = await axios.post('/feedback', { type, description, current_route });
    return { status: STATUS.SUCCESS, data: response.data.data };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

export async function getFeedback(params = {}) {
  try {
    const response = await axios.get('/feedback', { params });
    return { status: STATUS.SUCCESS, data: response.data.data };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

export async function updateFeedbackStatus(id, status) {
  try {
    const response = await axios.patch(`/feedback/${id}/status`, { status });
    return { status: STATUS.SUCCESS, data: response.data.data };
  } catch (error) {
    return extractErrorInfo(error);
  }
}
